<template>
  <div class="l_container">
    <h1>admin page.</h1>
    <section class="l_section">
      <div class="l_button">
        <button class="c_button" @click="tapTrackScreen">Analytics Screen Track</button>
      </div>
      <div class="l_button">
        <button class="c_button" @click="tapTrackEvent">Analytics Event Track</button>
      </div>
      <div class="l_button">
        <button class="c_button" id="annt29" @click="tapRequestToken">Request APIToken</button>
        <template v-if="this.token !== ''">
          <p>Token: {{this.token}}</p>
        </template>
      </div>
      <div class="l_button">
        <button class="c_button" @click="tapTestLoading">Test Laoding</button>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Admin',
  data: function () {
    return {
      token: ''
    }
  },
  created: function () {

  },
  methods: {
    ...mapActions('Analytics', ['trackScreen', 'trackEvent']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    tapTrackScreen () {
      try {
        const payload = {
          name: '0.クーポン',
          params: {
            screenClass: 'SampleViewController'
          }
        }
        this.trackScreen(payload)
      } catch (e) {
        console.warn(e)
      }
    },
    tapTrackEvent () {
      try {
        const payload = {
          name: 'Tap_Button',
          params: {
            itemId: '10003',
            itemName: 'アイテム名が入ります',
            contentType: 'Coupon'
          }
        }
        this.trackEvent(payload)
      } catch (e) {
        console.warn(e)
      }
    },
    tapRequestToken () {
      try {
        // Native側からの呼び出し
        window.receivedToken = (token, userId) => {
          this.token = token
        }
        this.actionRequestToken()
      } catch (e) {
        console.warn(e)
      }
    },
    tapTestLoading () {
      this.actionToggleLoading(true)
      setTimeout(() => { this.actionToggleLoading(false) }, 2000)
    }
  }
}
</script>

<style scoped>

.l_container {
  padding: 30px 15px;
}

.l_section {
  padding: 30px 0;
}

.l_button + .l_button {
  margin-top: 15px;
}

.c_button {
  background-color: #000;
  color: #ffffff;
  line-height: 1.0;
  padding: 15px;
  outline: none;
  appearance: none;
  border: none;
  width: 100%;
}

</style>
